import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import SearchTable from '@/components/SearchTable.vue';
import _ from 'lodash';
import VueMarkdown from 'vue-markdown';
import BackButton from '@/components/BackButton.vue';
const lightsaberFormsModule = namespace('lightsaberForms');
let CharacterslightsaberForms = class CharacterslightsaberForms extends Vue {
    constructor() {
        super(...arguments);
        this.initialSearch = '';
        this.tableType = 'Lightsaber Forms';
    }
    created() {
        this.fetchLightsaberForms();
        this.initialSearch = this.$route.query.search;
    }
    get items() {
        const page = this.isInHandbook ? 'phb' : 'characters';
        return _(this.lightsaberForms)
            .filter(({ contentType }) => !this.isInHandbook || contentType === 'Core')
            .map(lightsaberForm => ({
            ...lightsaberForm,
            id: lightsaberForm.name,
            isExpandable: lightsaberForm.description
        })).value();
    }
    get headers() {
        return [
            {
                text: 'Name',
                value: 'name'
            },
            {
                text: 'Source',
                value: 'contentSource',
                render: _.startCase,
                filterChoices: ['PHB', 'EC', 'WH'],
                filterFunction: ({ contentSource }, filterValue) => _.startCase(contentSource) === filterValue
            }
        ];
    }
};
__decorate([
    lightsaberFormsModule.State
], CharacterslightsaberForms.prototype, "lightsaberForms", void 0);
__decorate([
    lightsaberFormsModule.Action
], CharacterslightsaberForms.prototype, "fetchLightsaberForms", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], CharacterslightsaberForms.prototype, "isInHandbook", void 0);
CharacterslightsaberForms = __decorate([
    Component({
        components: {
            SearchTable,
            BackButton,
            VueMarkdown
        }
    })
], CharacterslightsaberForms);
export default CharacterslightsaberForms;
